import { SubscriptionCadence, LU_SubscriptionPriceModel } from 'starbase-launcher';
import { ITableColumn, TableColumn, ColumnDataTypes, DropdownTableColumn, ColumnDropdownData, CurrencyTableColumn } from 'new-table-editor';
import { UserGroupModel_ext } from './lu_usergroup';

export class SelectableTypeDef {
  selected: boolean;
  key: string;
  value: number;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export class LU_SubscriptionPriceModel_ext extends LU_SubscriptionPriceModel {

  private static cadenceEnum: SelectableTypeDef[] = Object.keys(SubscriptionCadence).filter(a => !(parseInt(a, 10) >= 0)).map(
    b => ({ selected: false, key: b, value: SubscriptionCadence[b] })
  );

  public cadenceDisp: SelectableTypeDef;
  public subscriptionUserGroup: UserGroupModel_ext;
  public squarePlanID: string;
  public taxable: boolean;
  public taxRate: number;
  public squareConfirmed: boolean;
  public accompanyingFilePath: string;
  public altFilePath: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static TableColumns(showUID = false, showGUID = false, showWhodunits = false, userGroups: UserGroupModel_ext[]): ITableColumn[] {
    const nameCol = new TableColumn('name', 'Name', ColumnDataTypes.string, true, true, true);

    const descriptionCol = new TableColumn('description', 'Description', ColumnDataTypes.string, false, true, false);

    const priceCol = new CurrencyTableColumn('price', 'Price', true, true, false);

    const cadenceCol = new DropdownTableColumn(
      'cadenceDisp',
      'Cadence',
      'cadence',
      new ColumnDropdownData(this.cadenceEnum),
      true,
      false,
      false
    );
    cadenceCol.dropdownData.setup('key', 'value');
    cadenceCol.editableNew = true;
    cadenceCol.tooltip = 'How often this subscription is charged';

    const userGroupCol = new DropdownTableColumn(
      'subscriptionUserGroup',
      'User Group',
      'subscriptionUserGroupUID',
      new ColumnDropdownData(userGroups),
      true,
      false,
      false
    );
    userGroupCol.dropdownData.setup('groupName', 'uid');
    userGroupCol.editableNew = true;
    userGroupCol.tooltip = 'User Group that will be applied to User Accounts with this subscription';

    const idCol = new TableColumn('squarePlanID', 'Subscription Id', ColumnDataTypes.string, false, false, false);
    idCol.colMaxWidth = '100px';
    idCol.tooltip = 'Square\'s unique ID for this subscription plan';
    idCol.dataTooltip = (data: LU_SubscriptionPriceModel_ext) => data.squarePlanID;
    const squareCol = new TableColumn('squareConfirmed', 'Square sync', ColumnDataTypes.yesno, false, false, false);
    squareCol.tooltip = 'Indicates if this plan was found on the Square side';
    // eslint-disable-next-line max-len
    squareCol.dataTooltip = (data: LU_SubscriptionPriceModel_ext) => { // HACK: We may eventually add a "real" way to dynamically change text colors.
      const connected = data.squareConfirmed;
      squareCol.columnTextColor = (connected ? 'limegreen' : 'red');
      return connected ? '' : 'Square returned an error when linking this plan';
    };
    const activeCol = new TableColumn('active', 'Active', ColumnDataTypes.yesno, false, true, false);

    return [
      ...TableColumn.generateColumnsForStarbaseEntity(showUID, showGUID, showWhodunits),
      nameCol,
      descriptionCol,
      priceCol,
      cadenceCol,
      userGroupCol,
      activeCol
    ];
  }

  deserialize(input) {
    return Object.assign(new LU_SubscriptionPriceModel_ext(), input);
  }
}
